<template>
  <v-dialog v-model="show" width="80%">
    <v-card>
      <v-card-title style="padding-left:8px;padding-bottom:8px">
        <span class="headline">海外取引先登録</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="!query.name || !query.displayName"
          @click="save"
          class="btn-search"
          >保存</v-btn
        >
        <v-btn @click="back">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="企業名称"
                v-model.trim="query.name"
              ></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="表示用略初"
                v-model.trim="query.displayName"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      query: {},
      show: false,
      resolve: null,
      reject: null,
      errors: {
        DUPLICATE_NAME:
          '海外取引先の名称が重複しているので、新規登録ができません。',
      },
    }
  },
  methods: {
    save() {
      this.$http
        .post(`/companies/create-temp-company`, this.query)
        .then((res) => {
          this.$message('', 'success')
          this.$emit('refreshPartner')
        })
        .catch((res) => {
          this.$showError(res)
        })
    },
    popup() {
      this.show = true
      // this.load()
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    back() {
      this.query = {}
      this.show = false
    },
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
}
</script>
